import React from 'react'
import type { UserNode } from '@/modules/users/types.graphql'
import { UserPlaceholder } from '@/modules/users/consts'

export const UserContext = React.createContext<UserNode>(UserPlaceholder)

export default UserContext
